<template>

  <ion-page >
    <ion-content style="height: 100%; overflow-y: auto">

      <!-- Swiper Section with Captions (unchanged) -->
      <ion-item
        style=" width: 100%; display: inline-flex; background-image: url('https://aes-site-assets.pages.dev/logo-resized.png');">
        <swiper-container :slides-per-view="1" :navigation="true" :pagination="true" :autoplay="true" :speed="500"
          class="responsive-swiper">
          <swiper-slide v-for="(slide, index) in slides" :key="index" style="position: relative;">
            <img class="swiper-image" :src="slide.image" :alt="'Slide ' + (index + 1)" />
            <div v-if="slide.caption" class="slide-caption">{{ slide.caption }}</div>
          </swiper-slide>
        </swiper-container>
      </ion-item>
      <ion-item>
        <div style="margin-left:41vw; overflow-x:none;overflow-y:none;">
          <h1><b>Coming Soon!</b></h1>
          <p style="color:#1C8AF7; margin-right:20vw; text-align: center;">
            Redirecting to Sister Site...<br />
          </p>
        </div>
      </ion-item>

    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import { IonContent, IonPage, IonItem, IonImg, IonButton, } from '@ionic/vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { register } from 'swiper/element/bundle';
register();
import { ref } from 'vue';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/swiper-bundle.css';
import 'swiper/css/scrollbar';
import { mobileBarWidth } from '@/helper';
setTimeout(() => {
  window.location.href = "https://aes-mlb.com";
}, 5000); // Redirect after 3 seconds
const bicsiLogo = "https://aes-site-assets.pages.dev/homepage/bicsi.png";
const isMobile = ref(false);
const slides = ref([
  { image: "https://aes-site-assets.pages.dev/scs/logo.png" },
  { image: "https://aes-site-assets.pages.dev/homepage/swiper/image2.jpg", caption: "LC Single Mode Fiber Patching" },
  { image: "https://aes-site-assets.pages.dev/homepage/swiper/image3.jpg", caption: "Meadowlane Primary Elementary Infrastructure Renewal" },
  { image: "https://aes-site-assets.pages.dev/homepage/swiper/image4.jpg", caption: "Meadowlane Primary Elementary Infrastructure Renewal" },
  { image: "https://aes-site-assets.pages.dev/homepage/swiper/image5.jpg", caption: "Wire Management using D-Rings and J-Hooks" },
  { image: "https://aes-site-assets.pages.dev/homepage/swiper/image6.jpg", caption: "110 Punch Block Terminations" },
  { image: "https://aes-site-assets.pages.dev/homepage/swiper/image7.jpg", caption: "Electrical Service Disconnect Installation" },
  { image: "https://aes-site-assets.pages.dev/homepage/swiper/image8.jpg", caption: "South West Middle School Chiller Plant" }
]);

setInterval(() => {
  isMobile.value = window.outerWidth <= mobileBarWidth;
}, 100);
</script>

<style scoped>
.swiper-parent {
  width: 100vw;
  display: flex !important;
  justify-content: center;
  align-items: center;
  background: transparent !important;
  border: none;
}

.responsive-swiper {
  width: 60vw;
  max-width: 900px;
  aspect-ratio: 16/9;
  min-width: 320px;
  min-height: 220px;
  max-height: 500px;
  border-radius: 32px;
  overflow: hidden;
  background: #18191a;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
  margin: 2vh auto 2vh auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.swiper-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  background: #18191a;
}

@media (max-width: 900px) {
  .responsive-swiper {
    width: 90vw;
    height: 32vh;
    min-width: 180px;
    min-height: 120px;
    border-radius: 16px;
  }
}

@media (max-width: 600px) {
  .responsive-swiper {
    width: 98vw;
    height: 24vh;
    min-width: 120px;
    min-height: 80px;
    border-radius: 10px;
  }
}

.slide-caption {
  position: absolute;
  bottom: 12px;
  right: 16px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 6px 10px;
  font-size: 0.9rem;
  border-radius: 4px;
}


</style>
